import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./ProjectCard.css";
import AOS from "aos";
import "aos/dist/aos.css";

const ProjectCard = ({ p }) => {
  useEffect(() => {
    AOS.init({ duration: 3000 });
    AOS.refresh();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div key={p.id} className="p-card" data-aos="fade-up">
      <Link
        to={`/project/${p.id}`}
        style={{ textDecoration: "none", color: "white" }}
      >
        <div className="card-box">
          <img src={p.image} alt={p.title} className="p-image" />
          <div className="space-b">
            <h1 className="p-title">{p.title}</h1>
            <img src={p.cardIcon} alt={p.title} className="p-icon" />
          </div>
          <h2 className="p-framework">{p.framework}</h2>
          <p className="p-detail">{p.detail.slice(0, 50)}...</p>
        </div>
      </Link>

      <div className="div-btn">
        <Link
          to={`/project/${p.id}`}
          style={{ textDecoration: "none", color: "white" }}
        >
          <button className="view-btn">View Project</button>
        </Link>
      </div>
    </div>
  );
};

export default ProjectCard;
